export function moveSizesToOptions(data) {
  if (!data) return [];

  return data.map((item) => ({
    value: item.id,
    label: item.name,
  }));
}

export function reportDataToCompaniesOptions(companies, allCompanies) {
  if (!companies) return [];

  const list = companies.map((company) => ({
    value: [company.id],
    label: company.company_name,
  }));

  if (allCompanies) {
    list.unshift({ value: allCompanies, label: 'All Companies' });
  }

  return list;
}

export function createMoveSizeRecord(moveSizes = []) {
  const record = {};

  moveSizes.forEach((size) => {
    record[size.id] = size;
  });

  return record;
}
